<div>
  <app-nav-bar>
    <main class="container-main">
      <ng-container *ngIf="haveContacts">
        <div class="row d-flex justify-content-between row-header-send">
          <ng-container>
            <div class="d-flex gap-8">
              <span class="contact-title"> Contatos salvos </span>
            </div>
          </ng-container>

          <div>
            <button
              type="button"
              class="btn btn-block btn-add-contact"
              (click)="openAddContactModal()"
              [ngClass]="
                companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
              "
              type="button"
            >
              Adicionar contato
            </button>

            <ng-template #bottomSheetContent>
              <app-add-contact></app-add-contact>
            </ng-template>
          </div>
        </div>
      </ng-container>

      <div
        *ngIf="!haveContacts && !showDataError && !loading"
        class="accordion-item painel painel-accordion no-contacts"
      >
        <div class="img-no-contacts">
          <img width="240" height="160" src="assets/image/no-order-icon.svg" />
        </div>

        <p id="txt-no-contacts-register">
          Você ainda não tem nenhum contato salvo.
        </p>
        <p id="txt-add-contact">
          Adicione um contato para facilitar o envio e recebimento <br />
          do exterior.
        </p>

        <div class="btn-send-content">
          <button
            class="btn btn-block mt-0 ml-3"
            (click)="openAddContactModal()"
            [ngClass]="
              companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
            "
            type="button"
          >
            <p>Adicionar contato</p>
          </button>
        </div>
      </div>

      <div
        *ngIf="loading"
        class="accordion-item painel painel-accordion error-orders"
      >
        <div class="img-error-orders">
          <span class="spinner-border text-primary" *ngIf="loading"></span>
        </div>
      </div>

      <div
        *ngIf="showDataError"
        class="accordion-item painel painel-accordion error-orders"
      >
        <div class="img-error-orders">
          <img
            width="258"
            height="160"
            src="assets/image/error-order-icon.svg"
          />
        </div>

        <p id="txt-error-orders-register">Infelizmente encontramos um erro!</p>
        <p id="txt-error-order">
          Você pode aguardar uns instantes e tentar recarregar a <br />página
          mais uma vez.
        </p>

        <div class="btn-send-content">
          <button
            (click)="reloadPage()"
            class="btn btn-block mt-0 ml-3"
            [ngClass]="
              companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
            "
            type="button"
          >
            Tentar Novamente
          </button>
        </div>
      </div>

      <ng-container *ngIf="haveContacts">
        <div class="box-order">
          <div class="padding-bottom-32 padding-top-10 header-box">
            <span class="mb-0">Lista de pagadores e beneficiários salvos</span>
          </div>

          <div class="padding-content">
            <ng-container *ngIf="!isMobile">
              <app-table-contacts-component
                *ngIf="showTables"
                [displayedColumns]="tableDisplayedColumns"
                [data]="userContacts"
              ></app-table-contacts-component>
            </ng-container>

            <ng-container *ngIf="isMobile">
              <app-contacts-mobile [data]="userContacts"></app-contacts-mobile>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </main>
  </app-nav-bar>
</div>
